import { createApp } from 'vue';
import App from './App.vue';
import router from './router/router';
import store from './store';
import { GraphQLClient } from 'graphql-request';

const graphcmsClient = new GraphQLClient('https://api-us-east-1.hygraph.com/v2/cl9dmxbr50f7p01uo8tms3vc0/master');

const app = createApp(App);
app.mixin({
    beforeCreate() {
        this.$graphcms = graphcmsClient;
    },
});
app.use(store).use(router).mount('#app');
